import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import performRequest from "../../api/request";
import { useSelector } from "react-redux";
import { FcAdvance } from "react-icons/fc";
import StepRoutes from "../../Routes/steps_routes";
import { useNavigate } from "react-router";
import { Toast } from "../../CustomComponent/toast";

const LeadTransfer = () => {
  const [users, setUsers] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [leadOptions, setLeadOptions] = useState([]);

  const [toOwner, setToOwner] = useState("");
  const [reason, setReason] = useState("");

  const [loadingLeads, setLoadingLeads] = useState(false);
  const [searchText, setSearchText] = useState("");

  let userData = useSelector((store) => store.login.user);

  let navigate = useNavigate();
  const debounceRef = useRef(null);

  // ---------------- USERS ----------------
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setUsers(res?.data || []))
      .catch(console.error);
  }, []);

  // ---------------- SEARCH LEADS ----------------
  const fetchLeads = async (inputValue) => {
    setLoadingLeads(true);

    try {
      const res = await performRequest(
        "GET",
        `/leads_v2/api/leads?search=${inputValue || ""}`
      );

      const options = res.data.map((lead) => ({
        value: lead.id,
        label: `${lead.full_name} (${lead.contact_number})`,
      }));

      setLeadOptions(options);
    } catch (err) {
      console.error(err);
    }

    setLoadingLeads(false);
  };

  const handleLeadSearch = (inputValue) => {
    setSearchText(inputValue);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchLeads(inputValue);
    }, 400);
  };

  // ---------------- REMOVE LEAD ----------------
  const removeLead = (id) => {
    setSelectedLeads((prev) => prev.filter((lead) => lead.value !== id));
  };

  // ---------------- TRANSFER ----------------
  const handleTransfer = async () => {
    if (!selectedLeads.length || !toOwner || !reason) {
      alert("Please select leads, owner and reason");
      return;
    }

    try {
      const leadIds = selectedLeads.map((l) => l.value);

      await performRequest("PATCH", "/leads_v2/leads/transfer", {
        leadIds,
        toOwnerId: toOwner,
        generatedBy: userData?.Name,
        reason,
      });

      navigate("/get-leads-transfer");
      Toast("sucess", "Lead Sucessfully Transfer");

      setSelectedLeads([]);
      setReason("");
      setToOwner("");
      setLeadOptions([]);
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-xl">
        {/* HEADER */}
        <div className="page-header d-print-none ">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title fw-bold">
                <FcAdvance></FcAdvance>Lead Transfer
              </h2>

              <div className="text-muted">
                <StepRoutes></StepRoutes>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* LEFT SIDE */}
          <div className="col-lg-5 mb-4">
            <div className="card shadow-sm">
              <div className="card-header">
                <h4 className="mb-0">Search Leads</h4>
              </div>

              <div className="card-body">
                <Select
                  isMulti
                  options={leadOptions}
                  value={selectedLeads}
                  onChange={setSelectedLeads}
                  onInputChange={handleLeadSearch}
                  isLoading={loadingLeads}
                  placeholder="Search by Name or Mobile..."
                  noOptionsMessage={() =>
                    searchText ? "No Leads Found" : "Start typing..."
                  }
                />
              </div>
            </div>

            {/* Selected Leads */}

            <div className="card mt-4 shadow-sm">
              <div className="card-header d-flex justify-content-between">
                <h4 className="mb-0">Selected Leads</h4>

                <span className="badge bg-yellow text-white">
                  {selectedLeads.length}
                </span>
              </div>

              <div
                className="card-body"
                style={{
                  maxHeight: "420px",
                  overflowY: "auto",
                }}
              >
                {selectedLeads.length === 0 ? (
                  <div className="text-center text-muted py-5">
                    No Leads Selected
                  </div>
                ) : (
                  selectedLeads.map((lead) => (
                    <div
                      key={lead.value}
                      className="border rounded p-3 mb-2 d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <strong>{lead.label}</strong>
                      </div>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeLead(lead.value)}
                      >
                        Remove
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}

          <div className="col-lg-7">
            <div className="card shadow-sm">
              <div className="card-header">
                <h4 className="mb-0">Transfer Details</h4>
              </div>

              <div className="card-body">
                <div className="mb-4">
                  <label className="form-label fw-bold">Transfer Owner</label>

                  <select
                    className="form-select"
                    value={toOwner}
                    onChange={(e) => setToOwner(e.target.value)}
                  >
                    <option value="">Select Owner</option>

                    {users.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.userName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-bold">Transfer Reason</label>

                  <textarea
                    rows="6"
                    className="form-control"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Write transfer reason..."
                  />
                </div>

                <div className="alert alert-info">
                  <strong>Total Selected :</strong> {selectedLeads.length} Lead
                  {selectedLeads.length > 1 ? "s" : ""}
                </div>

                <button
                  className="btn btn-primary btn-lg w-100"
                  disabled={!selectedLeads.length || !toOwner || !reason}
                  onClick={handleTransfer}
                >
                  🚀 Transfer {selectedLeads.length || ""}
                  {selectedLeads.length
                    ? ` Lead${selectedLeads.length > 1 ? "s" : ""}`
                    : " Leads"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadTransfer;
